/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresGetFileContent } from "../../funcs/llmVectorStoresGetFileContent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetVectorStoreFileContentRequest$inboundSchema,
};

export const tool$llmVectorStoresGetFileContent: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-get-file-content",
  description: `Retrieve parsed file content

Retrieves the complete parsed contents of a file within a vector store.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresGetFileContent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
